import { createFileRoute, redirect } from '@tanstack/react-router';
import { hasLivePortalSession } from '@/stores/portalAuth.store';

// Preserve saved links to the old list; proposal detail URLs remain unchanged.
export const Route = createFileRoute('/(portal)/portal/proposals/')({
  beforeLoad: () => {
    if (!hasLivePortalSession()) {
      throw redirect({ to: '/portal/login' });
    }
    throw redirect({ to: '/portal/estimates', replace: true });
  },
});
